import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHatChef } from '@fortawesome/free-solid-svg-icons';

export default function ChefAtelierSection() {
  return (
    <section id="atelier" className="py-24 lg:py-32 bg-cream-warm relative overflow-hidden">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-1/3 h-full bg-gradient-to-r from-blush/50 to-transparent pointer-events-none" />
      <div className="absolute bottom-0 right-0 w-1/3 h-1/2 bg-gradient-to-tl from-gold/5 to-transparent pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Content side */}
          <div>
            <span className="inline-block font-body text-sm text-burgundy uppercase tracking-[0.2em] mb-4">
              Animation Exclusive
            </span>
            <h2 className="font-serif font-semibold text-4xl md:text-5xl text-navy-900 mb-6 leading-tight">
              L'Art de la Galette
              <span className="block text-gradient-gold">en Direct</span>
            </h2>

            <div className="space-y-6 mb-10">
              <p className="font-body text-lg text-navy-600 leading-relaxed">
                Découvrez les secrets de la galette des rois grâce à une{' '}
                <strong className="font-semibold text-navy-800">démonstration en direct</strong> par
                notre chef pâtissier.
              </p>
              <p className="font-body text-navy-600 leading-relaxed">
                Un moment privilégié où petits et grands pourront observer
                les gestes précis du chef, de la préparation de la pâte
                feuilletée à la cuisson dorée, en passant par le secret
                d'une frangipane parfaite.
              </p>
            </div>

            {/* Highlights */}
            <ul className="space-y-4">
              <li className="flex items-start gap-4 group">
                <span className="flex-shrink-0 w-8 h-8 flex items-center justify-center bg-gold/10 text-gold group-hover:bg-gold group-hover:text-navy-900 transition-all duration-300">
                  <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M5 13l4 4L19 7" />
                  </svg>
                </span>
                <span className="font-body text-navy-700 pt-1">Atelier cuisine interactif avec le chef</span>
              </li>
              <li className="flex items-start gap-4 group">
                <span className="flex-shrink-0 w-8 h-8 flex items-center justify-center bg-gold/10 text-gold group-hover:bg-gold group-hover:text-navy-900 transition-all duration-300">
                  <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M5 13l4 4L19 7" />
                  </svg>
                </span>
                <span className="font-body text-navy-700 pt-1">Découverte des techniques de pâtisserie française</span>
              </li>
              <li className="flex items-start gap-4 group">
                <span className="flex-shrink-0 w-8 h-8 flex items-center justify-center bg-gold/10 text-gold group-hover:bg-gold group-hover:text-navy-900 transition-all duration-300">
                  <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M5 13l4 4L19 7" />
                  </svg>
                </span>
                <span className="font-body text-navy-700 pt-1">Animation conviviale pour toute la famille</span>
              </li>
            </ul>
          </div>

          {/* Image side */}
          <div className="relative">
            {/* Gold frame accent */}
            <div className="absolute -inset-4 border border-gold/30" />
            <div className="absolute -inset-8 border border-gold/10" />

            {/* Chef image */}
            <div className="relative aspect-[4/3] overflow-hidden bg-navy-100">
              <img
                src="/chef.jpg"
                alt="Le chef prépare la galette des rois"
                className="w-full h-full object-cover"
              />
              {/* Overlay gradient */}
              <div className="absolute inset-0 bg-gradient-to-t from-navy-900/20 to-transparent" />
            </div>

            {/* Floating badge */}
            <div className="absolute -bottom-6 -left-4 lg:-left-8 bg-burgundy text-cream p-6 shadow-elegant-lg hidden md:block">
              <div className="flex items-center gap-3">
                <svg className="w-8 h-8 text-gold" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M21 15.546c-.523 0-1.046.151-1.5.454a2.704 2.704 0 01-3 0 2.704 2.704 0 00-3 0 2.704 2.704 0 01-3 0 2.704 2.704 0 00-3 0 2.704 2.704 0 01-3 0 2.701 2.701 0 00-1.5-.454M9 6v2m3-2v2m3-2v2M9 3h.01M12 3h.01M15 3h.01M21 21v-7a2 2 0 00-2-2H5a2 2 0 00-2 2v7h18zm-3-9v-2a2 2 0 00-2-2H8a2 2 0 00-2 2v2h12z" />
                </svg>
                <div>
                  <p className="font-serif text-lg font-semibold">Atelier Live</p>
                  <p className="font-body text-sm text-cream/70">Avec notre chef</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
